/**
 * Public (token-gated, no-auth) email-preference endpoints backing the
 * /email-preferences unsubscribe page. The token from the email's visible
 * Unsubscribe link is the only credential — verify reads the category off it so
 * the page can name what's being turned off before the user confirms.
 *
 * Mirrors api/src/modules/email-preferences/email-preferences.controller.ts.
 */
import { apiJson } from '../api';

export type UnsubscribeCategory = 'episode-reminder';

export const CATEGORY_LABELS: Record<string, string> = {
  'episode-reminder': 'Weekly Episode Reminders',
};

export function categoryLabel(category: string): string {
  return CATEGORY_LABELS[category] ?? 'these emails';
}

export async function verifyUnsubscribeToken(token: string, init?: RequestInit): Promise<{ category: string }> {
  const res = await apiJson<{ status: number; data: { category: string } }>(
    `/email-preferences/verify?t=${encodeURIComponent(token)}`,
    init,
  );
  return res.data;
}

export async function confirmUnsubscribe(token: string): Promise<{ category: string }> {
  const res = await apiJson<{ status: number; data: { category: string } }>('/email-preferences/unsubscribe', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });
  return res.data;
}
